import { Modal } from '@fasstech/middle-design-system';

const ErrorOnSendForSignatureModal = ({
  isDisplayed,
  errorSendForSignatureModalMessage,
  setErrorSendForSignatureModalMessage
}) => {
  const hideModal = () => {
    setErrorSendForSignatureModalMessage('');
  };

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={'OK'}
      onClose={hideModal}
      onClick1={hideModal}
      icon="circleReject"
      className="w-[80vw] max-w-2xl">
      <div className="mx-auto text-primary font-medium text-xl text-center">
        <div className="text-2xl font-semibold mb-4">Attention</div>
        <p>{errorSendForSignatureModalMessage}</p>
      </div>
    </Modal>
  );
};

export default ErrorOnSendForSignatureModal;
